import Box from '@mui/material/Box';
import { MONO_FONT } from '@/theme';

export default function TagPill({
  children,
  active = false,
  onClick,
  href,
  dark = false,
}) {
  const base = {
    display: 'inline-flex',
    alignItems: 'center',
    fontFamily: MONO_FONT,
    fontSize: '11px',
    fontWeight: 500,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    px: '12px',
    py: '5px',
    border: '1px solid',
    cursor: onClick || href ? 'pointer' : 'default',
    textDecoration: 'none',
    transition: 'all 0.15s ease',
    borderRadius: '2px',
  };

  const activeStyle = {
    bgcolor: 'primary.dark',
    borderColor: 'primary.dark',
    color: 'common.white',
  };

  const inactiveStyle = dark
    ? {
        bgcolor: 'transparent',
        borderColor: 'grey.700',
        color: 'text.muted',
        '&:hover': { borderColor: 'grey.500', color: 'grey.200' },
      }
    : {
        bgcolor: 'transparent',
        borderColor: 'grey.200',
        color: 'grey.600',
        '&:hover': { borderColor: 'primary.main', color: 'text.accent' },
      };

  return (
    <Box
      component={href ? 'a' : onClick ? 'button' : 'span'}
      href={href}
      onClick={onClick}
      sx={{ ...base, ...(active ? activeStyle : inactiveStyle) }}
    >
      {children}
    </Box>
  );
}
